import React from "react";
import Background from "../../assets/img/new-logo-4-bg.png";
import { fetchZipcodeLinks, deleteZipCode } from "../../actions/customers";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { Loader } from "../loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import AddZipCode from "./addVeterinarian";
import _ from 'lodash';

const $ = window.$;
const { SearchBar } = Search;
var _self;


class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {    
    loading: true,
    zipcodeLinkData: [], 
    zipcodeLinkListError: {}, 
    selectedZipCodeLinkData: {},
    zipCodeId: null,

  };

  tableHeaderZipcodeLinksColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" },
      headerStyle: (column, colIndex) => {
        return { width: '100px' };
      }
    }, 
    {
      dataField: 'zip_code', 
      text: 'Zip Code',
       sort: true,
       headerStyle: (column, colIndex) => {
        return { width: '100px' };
      }
    },
    {
      dataField: 'name', text: 'Name', sort: true
    },
    {
      dataField: 'link', text: 'Link', sort: true
    },
        
    {
      dataField: 'createdAt',
       text: 'Created Date', 
       formatter: cell => moment(cell).format('MM-DD-YYYY h:mm:ss a'),
        sort: true,
        headerStyle: (column, colIndex) => {
          return { width: '200px' };
        }
    },
  ];

  buttonFormatter(cell, row, rowIndex) {  
    return (
      <div>    
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">         
             <a
                class="dropdown-item"
                onClick={(e) => { this.onZipCodeEditClick(e,row.id) }}
              >
                <i className="la la-edit"></i> Edit
              </a>   
              <a
                class="dropdown-item"
                onClick={(e) => { this.openZipCodeDeleteModal(e,row.id) }}
              >
                <i className="la la-trash-o"></i> Delete
              </a>
            </div>
          </span>
        </span>
      </div>
    );
  }

  componentDidMount() {  
    this.props.fetchZipcodeLinks();  
  }

  componentWillReceiveProps = nextProps => { 
    if (nextProps.zipcodeLinkList !== this.props.zipcodeLinkList) {
      this.setState({ zipcodeLinkData: nextProps.zipcodeLinkList, loading: false });
    }
    
    if(nextProps.zipcodeLinkListError !== this.props.zipcodeLinkListError){
      this.setState({ zipcodeLinkListError: nextProps.zipcodeLinkListError });
    }

    if(nextProps.deletedZipCode && nextProps.deletedZipCode !== this.props.deletedZipCode){
      NotificationManager.success('Zip code deleted successfully');
      this.props.fetchZipcodeLinks();  
      $('#confirm_delete_modal').modal('hide');
    }

    if (nextProps.deletedZipCodeError && this.props.deletedZipCodeError !== nextProps.deletedZipCodeError){      
      if (nextProps.deletedZipCodeError.message ) {
        NotificationManager.error(nextProps.updatedZipcodeError.message);
        this.setState({ loading: false });
      } else {
        NotificationManager.error("An error occurred while deleting the zip code" );
        this.setState({ loading: false });    
      }     
    }

  }

  onZipCodeEditClick = (e, id) => {
    e.preventDefault();    
    this.setState({ selectedZipCodeLinkData: null }, () => {
      let selectedZipCodeLinkData = _.find(this.state.zipcodeLinkData, { 'id': id });
      if (selectedZipCodeLinkData) {
        this.setState({ selectedZipCodeLinkData: selectedZipCodeLinkData  });
      }
      });
  }

  handlerZipCode = () => { 
    this.clearSelectedDataToEdit();
    this.props.fetchZipcodeLinks();
  }

  clearSelectedDataToEdit = () => {
    this.setState({
      selectedZipCodeLinkData :{},
    });
  }

  openZipCodeDeleteModal(e,zipCodeId) {  
    this.setState({zipCodeId: zipCodeId});
    $('#confirm_delete_modal').modal('show');
  }

  deleteZipCode(e){
    e.preventDefault();  
    let id = this.state.zipCodeId;
    this.props.deleteZipCode(id);
  }

  items = [{ title: "Zip Codes Links", to: "/customer/zip-code-link" }];

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const {  
      zipcodeLinkData,selectedZipCodeLinkData
    } = this.state;

    return (
      <div class="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop">      
        <div class="row align-items-center">
          <div class="col-xl-8 order-2 order-xl-1">
          </div>
          <div class="col-xl-4 order-1 order-xl-2 m--align-right">
            <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mb-4" data-toggle="modal" data-target="#add_zip_code">
                <span>
                  <i className="la la-plus"></i>
                  <span>New Veterinarian</span>
                </span>
              </button>  
              <div class="m-separator m-separator--dashed d-xl-none"></div>                         
          </div>
        </div>
        <div class="col-xl-12 order-2 order-xl-1">    
        {this.state.loading ?
        <div className="col-md-12" style={{ textAlign: 'center' }}>
           <Loader width="100px" height="100px;" />
        </div>:        
          <ToolkitProvider
           keyField="id"
           data={ zipcodeLinkData }
           columns={this.tableHeaderZipcodeLinksColumnData}
           search
           hover={true}
           filter={filterFactory()}
          >
            {props => (
              <div>
                <div className="px-0 mb-4 search-bar">
                  <div className="col-lg-3 px-0 inner-addon right-addon">
                    <i className="fas fa-search"></i>
                      <SearchBar {...props.searchProps} />
                  </div>
                </div>                 
                  <BootstrapTable
                   classes="petTable"
                   {...props.baseProps}
                    pagination={paginationFactory()}
                    />                        
              </div>
             )}
          </ToolkitProvider> 
       }
        </div>
        </div>
        <AddZipCode selectedZipCodeLinkData ={selectedZipCodeLinkData} actionZipCode={this.handlerZipCode}/>
         <div class="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Confirm To Delete</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure you want to delete this zip code?</p>
                        </div>
                        <div class="modal-footer">                    
                            <div>
                                <button type="button" class="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={(e) => this.deleteZipCode(e)} class="btn btn-primary m-btn--pill">Confirm</button>
                            </div>                    
                      
                        </div>
                    </div>
                </div>
        </div> 
      </div>
    );
  }
}

const mapStateToProps = state => ({  
  zipcodeLinkList: state.customersReducer.zipcodeLinkList,
  zipcodeLinkListError: state.customersReducer.zipcodeLinkListError,
  deletedZipCode: state.customersReducer.deletedZipCode,
  deletedZipCodeError: state.customersReducer.customersReducer,
});

const mapDispatchToProps = dispatch => ({

  fetchZipcodeLinks: ()=> {
    dispatch(fetchZipcodeLinks());
  },
  deleteZipCode: (id) => {
    dispatch(deleteZipCode(id));
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);